import TagManager from 'react-gtm-module';

declare global {
	// tslint:disable-next-line: interface-name
	interface Window {
		dataLayer: Array<{}>;
	}
}

// Make sure to update this in Portal-Next if you update it here
export const LOGIN_SUCCESS_GTM_EVENT = 'UserLoginSuccess';

export interface ITrackingProps {
	userId: string;
	email: string;
	name?: string;
	companyName?: string;
}

export const initialiseFullStory = async () => {
	const orgId = process.env.FULL_STORY_ORG_ID || '';
	const loader: any = await import('./92b3b47/assets/scripts/fullStory');
	await loader.default(orgId);
};

export const initialiseGoogleTagManager = () => {
	getDataLayer().initialise();
	TagManager.initialize({
		gtmId: process.env.GOOGLE_TAG_MANAGER_ID
	});
};

export const sendCustomGtmEvent = (eventName: string, eventData: any) => {
	getDataLayer().initialise();
	window.dataLayer.push({
		event: eventName,
		...eventData
	});
};

export const getDataLayer = () => {
	return {
		initialise: () => window.dataLayer = window.dataLayer || (window.dataLayer = []),
		set: (key: string, value: string) => {
			getDataLayer().initialise();
			window.dataLayer.push({ [key]: value });
		}
	};
};

export const setFullStoryUserId = (userId: string) => {
	getDataLayer().set('travelnest_owner_id', userId);
	const FS = (window as any).FS;
	if (FS && FS.identify && typeof FS.identify === 'function') {
		FS.identify(userId, {
			displayName: userId,
		});
	} else {
		// removed this error for now as we're not doing anything about it
		// logging.error('Failed to set fullstory identity, window.FS.identity is not a function');
	}
};

export const sendCustomFullStoryEvent = (eventName: string, eventData: any) => {
	const FS = (window as any).FS;
	try {
		FS.event(eventName, eventData);
	} catch (e) {
		console.warn('Could not send custom event to fullStory');
		console.warn(e);
	}
};
